import React, { useCallback, useRef, useState } from "react";
import Select from "react-select";

const MultiSelectDropdown = ({
  value,
  onChange,
  label,
  options,
  isDisabled,
  classNameError,
  error,
  placeholder,
  menuPlacement = "auto",
  maxMenuHeight = 180,
}) => {
  const wrapRef = useRef(null);
  const [fittedMaxHeight, setFittedMaxHeight] = useState(maxMenuHeight);
  const hasError = Boolean(
    typeof error === "string" ? error.trim() : error && Object.keys(error).length > 0
  );

  const fitMenuToViewport = useCallback(() => {
    const el = wrapRef.current;
    if (!el) {
      setFittedMaxHeight(maxMenuHeight);
      return;
    }

    const rect = el.getBoundingClientRect();
    const gutter = 56;
    const spaceBelow = window.innerHeight - rect.bottom - gutter;
    const spaceAbove = rect.top - gutter;
    const available =
      menuPlacement === "top"
        ? spaceAbove
        : menuPlacement === "bottom"
          ? spaceBelow
          : Math.max(spaceBelow, spaceAbove);

    setFittedMaxHeight(Math.max(72, Math.min(maxMenuHeight, available)));
  }, [maxMenuHeight, menuPlacement]);

  return (
    <div ref={wrapRef}>
      <div className={`select_hold ${hasError ? "errorborder-select" : ""}`}>
      {label && <label>{label}</label>}
      <Select
        value={value || []}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        isMulti={true}
        isClearable={true}
        isDisabled={isDisabled}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        menuPlacement={menuPlacement}
        menuShouldScrollIntoView={false}
        maxMenuHeight={fittedMaxHeight}
        onMenuOpen={fitMenuToViewport}
        onFocus={fitMenuToViewport}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 10050 }),
          menu: (base) => ({ ...base, zIndex: 10050 }),
          menuList: (base) => ({
            ...base,
            maxHeight: fittedMaxHeight,
            overflowY: "auto",
          }),
        }}
      />
      </div>
      {hasError && (
        <span className={`${classNameError} text-input-error`}>
          {typeof error === "string" ? error : ""}
        </span>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
